var composeValidators = function composeValidators() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }
  return function (value) {
    return validators.reduce(function (error, validator) {
      return error || validator(value);
    }, undefined);
  };
};
var isRequired = function isRequired(value) {
  return !value && 'Required';
};
var checkboxRequired = function checkboxRequired(value) {
  if (Array.isArray(value) && value.length < 1 || !Array.isArray(value) && !value) {
    return 'Required';
  }
  return null;
};
var isNumeric = function isNumeric(value) {
  return !/(^[0-9]*$)/.test(value) && 'Must be a number';
};
var zip = function zip(value) {
  return !/(^\d{5}$)/.test(value) && 'Must be a valid zipcode';
};
var email = function email(value) {
  return !/.+@.+\..+/.test(value) && 'Invalid email';
};
var phone = function phone(value) {
  return !/^[(]?[0-9]{3}[)]?[ .-]?[0-9]{3}[ .-]?[0-9]{4}$/.test(value) && 'Invalid number';
};
var determineValidations = function determineValidations(field) {
  var type = field.type,
    name = field.name,
    required = field.required,
    min = field.min,
    max = field.max;
  var validations = [];
  if (type === 'checkbox' && required) {
    validations.push(checkboxRequired);
  } else if (required) {
    validations.push(isRequired);
  }
  var textTypes = ['text', 'email', 'search', 'password'];
  if (type === 'number' && min) validations.push(function (value) {
    return value < min && "Must be at least ".concat(min);
  });
  if (type === 'number' && max) validations.push(function (value) {
    return value > max && "Must be less than ".concat(max);
  });
  if (textTypes.includes(type) && min) validations.push(function (value) {
    return value && value.length < min && "Must be at least ".concat(min, " characters");
  });
  if (textTypes.includes(type) && max) validations.push(function (value) {
    return value && value.length > max && "Must be less than ".concat(max, " characters");
  });
  if (type === 'number') validations.push(isNumeric);
  if (type === 'email') validations.push(email);
  if (name === 'zip_postal') validations.push(zip);
  if (type === 'tel') validations.push(phone);
  return composeValidators.apply(void 0, validations);
};

export { checkboxRequired, composeValidators, determineValidations, email, isNumeric, isRequired, phone, zip };
//# sourceMappingURL=validations.js.map
